import { BRIDGE_NUMBERS_LOADING, BRIDGE_NUMBERS_SUCCESS, BRIDGE_NUMBERS_FAILED, ACTIVE_BRIDGE_NUMBERS_LOADING, ACTIVE_BRIDGE_NUMBERS_SUCCESS, ACTIVE_BRIDGE_NUMBERS_FAILED } from '../actions/voiceLogs.action';
import { BridgeNumberReducer } from '../models/voiceLogs.interface';

const initialState: BridgeNumberReducer = {
    bridgeNumbersData: {},
    bridgeNumberLoading: false,
    bridgeNumberError: false,
    bridgeNumberErrorMsg: ''
}

export const bridgeNumberReducer = (state: BridgeNumberReducer = initialState, action: any): BridgeNumberReducer => {

    switch (action.type) {
        case BRIDGE_NUMBERS_LOADING:
            return {
                ...state,
                bridgeNumberLoading: true,
                bridgeNumberError: false
            }
        case BRIDGE_NUMBERS_SUCCESS:
            return {
                ...state,
                bridgeNumberLoading: false,
                bridgeNumberError: false,
                bridgeNumbersData: action.payload.res,
            }
        case BRIDGE_NUMBERS_FAILED:
            return {
                ...state,
                bridgeNumberLoading: false,
                bridgeNumberError: true,
                bridgeNumberErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}



const initialActiveBridgeState: BridgeNumberReducer = {
    bridgeNumbersData: {},
    bridgeNumberLoading: false,
    bridgeNumberError: false,
    bridgeNumberErrorMsg: ''
}

export const activeBridgeNumberReducer = (state: BridgeNumberReducer = initialActiveBridgeState, action: any): BridgeNumberReducer => {

    switch (action.type) {
        case ACTIVE_BRIDGE_NUMBERS_LOADING:
            return {
                ...state,
                bridgeNumberLoading: true,
                bridgeNumberError: false
            }
        case ACTIVE_BRIDGE_NUMBERS_SUCCESS:
            return {
                ...state,
                bridgeNumberLoading: false,
                bridgeNumberError: false,
                bridgeNumbersData: action.payload.res,
            }
        case ACTIVE_BRIDGE_NUMBERS_FAILED:
            return {
                ...state,
                bridgeNumberLoading: false,
                bridgeNumberError: true,
                bridgeNumberErrorMsg: action.payload.error
            }
        default:
            return state;
    }
}

